var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategiclogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_581_419)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4191 29.8548C50.6812 32.1354 51.4011 34.7561 51.4011 37.542C51.4011 46.3246 44.256 53.4697 35.4734 53.4697C26.6908 53.4697 19.5458 46.3246 19.5458 37.5421C19.5458 28.7597 26.6908 21.6145 35.4734 21.6145C38.1893 21.6145 40.7483 22.2985 42.988 23.5021L46.2679 20.2222C43.0611 18.2151 39.35 17.1401 35.4733 17.1401C30.0238 17.1401 24.9003 19.2623 21.0469 23.1157C17.1934 26.9692 15.0713 32.0926 15.0713 37.5422C15.0713 42.9917 17.1934 48.1152 21.0469 51.9685C24.9004 55.8221 30.0238 57.9442 35.4733 57.9442C40.9228 57.9442 46.0463 55.8221 49.8997 51.9685C53.7532 48.1151 55.8754 42.9917 55.8754 37.5422C55.8754 33.5994 54.7639 29.8278 52.6901 26.5838L49.4191 29.8548Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0348 33.7717C35.5661 33.1699 33.8088 33.459 32.6177 34.6503C31.0285 36.2395 31.0285 38.803 32.6177 40.3799C34.2062 41.9684 36.7697 41.9684 38.3464 40.3799C39.5383 39.1878 39.8268 37.4307 39.225 35.9628L50.8638 24.3241L52.8021 24.5767L57.929 19.4491L54.0538 18.932L53.536 15.0562L48.4084 20.1955L48.6617 22.1331L37.0348 33.7717Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0625 36.211C43.1381 36.6434 43.1779 37.0881 43.1779 37.5419C43.1779 41.7904 39.7216 45.2467 35.4731 45.2467C31.2247 45.2467 27.7683 41.7905 27.7683 37.5419C27.7683 33.2936 31.2246 29.8372 35.4731 29.8372C35.8467 29.8372 36.214 29.8645 36.5736 29.9161L40.1802 26.3095C38.7313 25.7001 37.141 25.3628 35.4731 25.3628C28.7575 25.3628 23.2939 30.8264 23.2939 37.5419C23.2939 44.2575 28.7575 49.7212 35.4731 49.7212C42.1887 49.7212 47.6523 44.2575 47.6523 37.5419C47.6523 35.8023 47.2849 34.1471 46.6249 32.6486L43.0625 36.211Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_581_419",
    x1: 2,
    y1: 2.5,
    x2: 71,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategiclogo2);
export default __webpack_public_path__ + "static/media/strategiclogo2.767941d1f520711e71f4c9ed1076903e.svg";
export { ForwardRef as ReactComponent };